export default __webpack_public_path__ + "static/media/04.585a9343.jpg";